import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

export const RequireExactMatchInput = memo(function RequireExactMatchInput({
  requireExactMatch,
  onRequireExactMatchChange,
}: {
  requireExactMatch?: boolean;
  onRequireExactMatchChange: (requireExactMatch: boolean) => void;
}) {
  const { t } = useTranslation();
  const setRequireExactMatch = useHandler((value: boolean) => {
    onRequireExactMatchChange(value);
  });
  return (
    <Flex w="full">
      <RedoCheckbox
        label={t("Require exact match")}
        setValue={setRequireExactMatch}
        size="xs"
        value={requireExactMatch ?? true} // default to true
      />
    </Flex>
  );
});
